import * as React from 'react';

import ImagePreviewer from '~shared/components/ImageField/ImagePreviewer';
import { RichTextRenderer } from '~shared/components/RichTextRenderer';
import { ImageResource, QuizAnswer } from '~teacher/models/quizzes';

function AnswerDisplay({
  text,
  id,
  image,
}: {
  text: string;
  id: number | string;
  image: ImageResource;
}) {
  return (
    <>
      {text ? <RichTextRenderer key={`answer-${id}`} htmlText={text} /> : null}
      {image ? (
        <div className="relative inline-flex">
          <ImagePreviewer
            containerStyle="inline-flex rounded-1"
            imageStyle="max-h-64 rounded-1"
            imageURL={image.urlS}
            showOutline
            allowZoom
            zoomImageURL={image.url}
          />
        </div>
      ) : null}
      {!text && !image ? <div className="h-8" /> : null}
    </>
  );
}

export function QuestionMatchingAnswerPairDisplay({
  answerPrompt,
  answerMatch,
}: {
  answerPrompt: QuizAnswer;
  answerMatch: QuizAnswer;
}) {
  return (
    <div>
      Prompt
      {answerPrompt ? (
        <AnswerDisplay
          text={answerPrompt.text}
          id={answerPrompt.id}
          image={answerPrompt.image}
        />
      ) : (
        <div>No prompt</div>
      )}
      Match
      {answerMatch ? (
        <AnswerDisplay
          text={answerMatch.text}
          id={answerMatch.id}
          image={answerMatch.image}
        />
      ) : (
        <div>no match</div>
      )}
    </div>
  );
}
